export enum WoundtrackStep {
  WOUNDSIZE = 'woundsize',
  WOUNDTYPE = 'woundtype',
}
